import { html } from '../utilities/html.js';
import { icon } from '../utilities/icons.js';
import { brand } from '../brand.js';
import { brandMark } from './visuals.js';
import { satisfies } from '../permissions/permissions.js';

/** Sidebar navigation filtered by the caller's permissions (UX only — the server re-checks). */
export function sidebar({ groups, items, permissions, membership }) {
  const visible = items.filter((i) => satisfies(permissions, i.permission));
  return html`
    <div class="sidebar__brand">
      ${brandMark(34)}
      <div class="sidebar__brand-text">
        <span class="sidebar__brand-name">${brand.productName}</span>
        <span class="sidebar__brand-sub">${brand.companyName}</span>
      </div>
    </div>
    <nav class="sidebar__nav" aria-label="Main">
      ${groups.map((g) => {
        const groupItems = visible.filter((i) => i.group === g.id);
        if (!groupItems.length) return '';
        return html`<div class="nav-group">
          <div class="nav-group__label" id="nav-${g.id}">${g.label}</div>
          <ul role="list" aria-labelledby="nav-${g.id}" style="list-style:none;padding:0;display:grid;gap:2px">
            ${groupItems.map((i) => html`<li><a class="nav-link" href="${i.path}" data-nav-path="${i.path}">${icon(i.icon)}<span>${i.label}</span></a></li>`)}
          </ul>
        </div>`;
      })}
    </nav>
    <div class="sidebar__footer">
      <div class="org-chip">
        <span class="stat-card__icon" style="position:static;width:34px;height:34px">${icon('building')}</span>
        <div style="min-width:0">
          <div class="org-chip__name truncate">${membership?.org_name ?? ''}</div>
          <div class="org-chip__meta truncate">${membership?.role_name ?? ''}</div>
        </div>
      </div>
    </div>`;
}

export function highlightActiveNav(root, items, pathname) {
  root.querySelectorAll('[data-nav-path]').forEach((a) => {
    const item = items.find((i) => i.path === a.dataset.navPath);
    const active = item?.match ? item.match.test(pathname) : pathname === a.dataset.navPath;
    if (active) a.setAttribute('aria-current', 'page');
    else a.removeAttribute('aria-current');
  });
}
